module.exports = __webpack_public_path__ + "img/pt1.7aab403c.png";